import { NavigationUserEvents } from "~/modules/analytics/events/navigation";
import { getButtonClassName } from "../Button";
import { ButtonVariants } from "../Button";
import { DefaultFormModal } from "../DefaultFormModal";

// // // //

export function CRMForms(props: {
    buttonText?: React.ReactNode;
    buttonClassName?: string;
    analyticsLabel?: string;
    analyticsEventProperties?: Record<string, unknown>;
}) {
    const {
        buttonText = "Contact",
        buttonClassName = getButtonClassName({
            size: "sm",
            rounded: false,
            variant: ButtonVariants.primary,
        }),
        analyticsLabel = NavigationUserEvents.navbarRequestDemoClick,
        analyticsEventProperties,
    } = props;
    return (
        <DefaultFormModal
            title="Contact the team"
            body="Get in touch about our API, data downloads, asset / network integrations, or anything else you have in mind. We are also available at team@rwa.xyz and usually respond within 24 hours. "
            buttonText={buttonText}
            buttonClassName={buttonClassName}
            analyticsLabel={analyticsLabel}
            analyticsEventProperties={analyticsEventProperties}
        />
    );
}
